export * from '../dist/ionicons/svg/index.mjs';